import { render, staticRenderFns } from "./TrayArrowUp.vue?vue&type=template&id=ae55bf4e"
import script from "./TrayArrowUp.vue?vue&type=script&lang=js"
export * from "./TrayArrowUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports